import { DataProviderArgs } from "../../DataStore/DataProvider";
import { IPlaceMediaItem } from "../../models/Models";
import { GraphQLTable } from "./GraphQLTable";
import { IPlaceMediaTable } from "../IPlaceMediaTable";
import {
    awsMediaInfoToSimpleMediaInfo,
    simpleMediaInfoToAwsMediaInfo,
} from "../cloud/PlaceMediaTable";
import { PlaceMediaItem } from "../../../models";

export class PlaceMediaTable extends GraphQLTable<IPlaceMediaItem> implements IPlaceMediaTable {
    private _allByPlaceId = new Map<string, IPlaceMediaItem[]>();

    constructor(args: DataProviderArgs) {
        super(
            args,
            [],
            {
                get: "getPlaceMediaItem",
                list: "listPlaceMediaItems",
                create: "createPlaceMediaItem",
            },
            (obj: PlaceMediaItem) => awsMediaInfoToSimpleMediaInfo(obj),
            (obj: IPlaceMediaItem) => simpleMediaInfoToAwsMediaInfo(obj)
        );
    }

    public async allByPlaceId(id: string, ..._args: any[]): Promise<IPlaceMediaItem[] | undefined> {
        if (this._allByPlaceId.has(id)) {
            return this._allByPlaceId.get(id);
        }

        const items = Array.from(
            await this._allAux({
                placeMediaId: {
                    eq: id,
                },
            })
        );

        if (items) {
            //this._notifyListeners(new ChangeSet([item], [], []));
            this._allByPlaceId.set(id, items);
            return items;
        }
        return undefined;
    }
}
